import { RadiologyBoxIcon } from './RadiologyBoxIcon';

/**
 * author: Simran
 * id 17B9888B-F36F-4D44-9318-BBB6ADA0F61B
 * name radiology-box
 * version: 5.3.45
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/radiology-box.svg
 * tags
 * - Medical / Hospital 
 */
export const XRayBoxIcon = RadiologyBoxIcon;
export default XRayBoxIcon